import {observable} from 'mobx';

/**
 * State class for the Image Editor component
 * Contains only observable data properties (no actions)
 */
export class ImageEditorState {
    @observable
    newUi?: boolean;

    @observable
    disablePadding?: boolean;

    @observable
    tagsOpen: boolean = false;

    @observable
    tags: string[] = [];

    @observable
    tagsResourceUrl?: string;

    originalTags: string[] = [];

    /**
     * Whether the "SCANNING" label should be displayed
     * True when actively scanning an area of the image
     */
    @observable
    labelMode: boolean = false;

    @observable
    isCanvasReadyWithImage: boolean = false;

    /**
     * Current annotation tool (arrow, rectangle, circle, pen, text, etc.)
     * Persists across canvas re-initialization during mode switches
     */
    @observable
    activeAnnotationTool: string | null = 'arrow';
}
